import CricketScoreboardImpl from './cricket-scoreboard.js';
import MojitoCore from 'mojito/core';
import { getPropTypes } from 'presentation/components/scoreboard/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * View to show a cricket scoreboard.
 *
 * @class CricketScoreboard
 * @memberof Mojito.Presentation.Components.Scoreboard
 */

/**
 * CricketScoreboard prop types.
 *
 * @extends Mojito.Presentation.Components.Scoreboard.default.ScoreboardPropTypes
 * @memberof Mojito.Presentation.Components.Scoreboard.CricketScoreboard
 */
const propTypes = { ...getPropTypes() };

export default UIView('CricketScoreboard', CricketScoreboardImpl, propTypes);
